// extracted by mini-css-extract-plugin
export default {"mainSnackBarWrap":"styles_mainSnackBarWrap__ylbys","fadeIn":"styles_fadeIn__lYYeR","fadeOut":"styles_fadeOut__vgUOD"};